export default __webpack_public_path__ + "static/media/Samsung_Logo2.9adadeee.svg";